import React, { useState } from 'react';
import { Popover, Box, Text } from '@wix/design-system';
import { useTranslation } from 'react-i18next';
import { PaymentCycle } from 'enums';

interface DisabledCyclePopoverProps {
  children: React.ReactNode;
  currentCycle: PaymentCycle;
}

export const DisabledCyclePopover: React.FC<DisabledCyclePopoverProps> = ({
  children,
  currentCycle,
}) => {
  const { t } = useTranslation();
  const [shown, setShown] = useState(false);

  return (
    <Box align='center' verticalAlign='middle'>
      <Popover
        onMouseEnter={() => setShown(true)}
        onMouseLeave={() => setShown(false)}
        showArrow
        animate
        placement='bottom'
        shown={shown}
      >
        <Popover.Element>{children}</Popover.Element>
        <Popover.Content>
          <Box padding='12px 24px' width={150}>
            <Text size='small'>
              {t(
                'premium-purchase-plan.package_picker_and_cycle_selector.change_cycle_tooltip',
                {
                  cycle: currentCycle,
                },
              )}
            </Text>
          </Box>
        </Popover.Content>
      </Popover>
    </Box>
  );
};
